<script>
export default {
  props: {
    x: {
      type: Number,
      default: 0,
    },
    y: {
      type: Number,
      default: 0,
    },
    placement: {
      type: String,
      default: 'right',
    },
  },
  data() {
    return {
      left: this.x,
      top: this.y,
      show: false,
    };
  },
  computed: {
    style() {
      return {
        top: this.top + 'px',
        left: this.left + 'px',
        transform: this.placement === 'left' ? 'translateX(-100%)' : 'none',
      };
    },
  },
  mounted() {
    this.$nextTick(() => this.$el.focus());
  },
  methods: {
    // The menu closes when focus leaves it, not when focus moves between its
    // own parts. Items are focusable (keyboard access), so pressing the mouse on
    // one moves focus from this container to the item; closing on that blur
    // unmounts the menu before the click lands. `relatedTarget` is where focus
    // is going: inside the menu keeps it open, outside (or nowhere, as when the
    // window loses focus) closes it, as before.
    onFocusOut(event) {
      if (this.$el.contains(event.relatedTarget)) return;
      this.$emit('close');
    },
  },
};
</script>

<template>
  <div
    class="fixed outline-none z-[9999] cursor-pointer"
    :style="style"
    tabindex="0"
    @focusout="onFocusOut"
  >
    <slot />
  </div>
</template>
